import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col, FormGroup } from 'reactstrap';
import cn from 'classnames';
import { FMessage } from '../../hoc/IntlComponents';

const types = {
  link: '/tools/flows/create',
  // tds: '/tools/streams/tds/create'
};

const FlowToggleBtns = ({ history }) => {
  const isActive = (path) => {
    const {
      location: { pathname },
    } = history;
    return pathname === path;
  };
  const handleChange = (path) => history.push(path);
  return (
    <FormGroup>
      <Row>
        <Col>
          <ul className="sub-sections list-inline">
            {Object.keys(types).map((key) => (
              <li key={key} className="list-inline-item">
                <Button
                  className={cn('sub-section-btn', { current: isActive(types[key]) })}
                  type="button"
                  size="md"
                  color="light"
                  onClick={() => handleChange(types[key])}
                  outline
                >
                  <FMessage id={`flow.toggle.${key}`} />
                </Button>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </FormGroup>
  );
};

export default withRouter(FlowToggleBtns);
